// Extras API for Analyze / Enrich / Copilot / Integrations / Team / Billing / Settings
import { api } from "@/lib/api";

export const extrasApi = {
    analyzeOverview: () => api.get("/analyze/overview").then(r => r.data),
    bulkReveal: (lead_ids, field) => api.post("/leads/bulk-reveal", { lead_ids, field }).then(r => r.data),
    copilotChat: (message, history = []) => api.post("/copilot/chat", { message, history }).then(r => r.data),
    integrationsCatalog: () => api.get("/integrations/catalog").then(r => r.data),
    apiKeys: {
        list: () => api.get("/api-keys").then(r => r.data),
        create: (name) => api.post("/api-keys", { name }).then(r => r.data),
        remove: (id) => api.delete(`/api-keys/${id}`).then(r => r.data),
    },
    team: {
        list: () => api.get("/team").then(r => r.data),
        invite: (email, role) => api.post("/team/invite", { email, role }).then(r => r.data),
        updateRole: (user_id, role) => api.patch(`/team/${user_id}/role`, { role }).then(r => r.data),
        cancelInvite: (invite_id) => api.delete(`/team/invite/${invite_id}`).then(r => r.data),
    },
    billing: {
        plan: () => api.get("/billing/plan").then(r => r.data),
        packs: () => api.get("/billing/packs").then(r => r.data),
        invoices: () => api.get("/billing/invoices").then(r => r.data),
        checkout: (pack_id) => api.post("/payments/checkout", { pack_id, origin_url: window.location.origin }).then(r => r.data),
        status: (session_id) => api.get(`/payments/status/${session_id}`).then(r => r.data),
    },
    updateMe: (body) => api.patch("/me", body).then(r => r.data),
    updateOrg: (body) => api.patch("/organization", body).then(r => r.data),
    rgpdExport: () => api.get("/me/export").then(r => r.data),
    rgpdDelete: () => api.delete("/me").then(r => r.data),
    visits: {
        summary: () => api.get("/visits/summary").then(r => r.data),
        recent: () => api.get("/visits/recent").then(r => r.data),
    },
    enrich: {
        providers: () => api.get("/enrich/providers").then(r => r.data),
        aiGuess: (lead_ids) => api.post("/enrich/ai-guess", { lead_ids }).then(r => r.data),
        hunter: (lead_ids) => api.post("/enrich/hunter", { lead_ids }).then(r => r.data),
        xcrawlPhone: (lead_ids) => api.post("/enrich/xcrawl-phone", { lead_ids }).then(r => r.data),
    },
    ratings: {
        rate: (lead_id, rating, reason) => api.post(`/leads/${lead_id}/rate`, { rating, reason }).then(r => r.data),
        get: (lead_id) => api.get(`/leads/${lead_id}/rating`).then(r => r.data),
        clear: (lead_id) => api.delete(`/leads/${lead_id}/rate`).then(r => r.data),
        bulkGet: (lead_ids) => api.post("/ratings/bulk-get", { lead_ids }).then(r => r.data),
        quota: () => api.get("/ratings/quota").then(r => r.data),
    },
    boxemate: {
        plan: (prompt) => api.post("/boxemate/plan", { prompt }).then(r => r.data),
        execute: (plan) => api.post("/boxemate/execute", { plan }).then(r => r.data),
    },
    whyMatch: (lead_id, context) => api.post(`/leads/${lead_id}/why-match`, { context: context || null }).then(r => r.data),
    downloadDpa: async () => {
        const r = await api.get("/dpa/download", { responseType: "blob" });
        const url = URL.createObjectURL(r.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = "boxeb2b-dpa.pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    },
};

// Tiny bilingual helper — used by Sprint C+ pages (no need for a full translations file update).
export function bl(en, fr, locale) {
    return locale === "fr" ? fr : en;
}
